import styled from 'styled-components';

import { Typography } from '@libs/components';

export const Container = styled.div`
  padding: 3.6rem 2.2rem;
  ${({ theme }) => theme.media.laptop`
    padding: 3.6rem;
    max-width: 50rem;
    justify-self: center;
  `}
`;

export const LottieWrapper = styled.div`
  width: 12.4rem;
  justify-self: center;
  margin-bottom: 2.5rem;
`;

export const CustomTypography = styled(Typography)`
  text-align: center;
`;

export const DescTypography = styled(Typography)`
  text-align: center;
  white-space: pre-line;
`;

export const MainContent = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 1.2rem;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  margin-top: 2.4rem;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  justify-self: center;
  width: 7rem;
  height: 7rem;
  margin-bottom: 3.2rem;
  background-color: ${({ theme }) => theme.colors.interactive.secondary};
  border-radius: 50%;
`;
